module.exports = __webpack_public_path__ + "img/AMBS.4465e568.webp";